"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarError = void 0;
var _mui = require("@ori-ui/mui");
const topNavHeightStyle = 'var(--top-nav-height, 0)';
const SnackbarError = exports.SnackbarError = (0, _mui.styled)(_mui.Snackbar)(({
  theme
}) => ({
  transform: `translate(0, ${topNavHeightStyle})`,
  transition: `transform var(--top-nav-height-animation), 0.3s ease-in-out`,
  [theme.breakpoints.up('sm')]: {
    top: '8px'
  }
}));
//# sourceMappingURL=styles.js.map